export const MEDIA_PATH = '/media'

export const MEDIA_API_PATHS = {
  TEACHER_UPLOAD_SIGNUP: `${MEDIA_PATH}/teacher-signup-media`,
}
